<form #form="ngForm" class="container-form" novalidate>
    <!--Options-->
    <div class="row container-form-options">
        <div class="col-12">
            <button type="button" class="btn btn-success mr-2" (click)="save()" id="btnSave">
                <i class="fas fa-check" aria-hidden="true"></i> Salvar
            </button>
                <button type="button" class="btn btn-light" (click)="cancel()">
                <i class="fas fa-undo" aria-hidden="true"></i> Cancelar
            </button>
        </div>
    </div>

    <!--Content-->
    <div class="row container-form-content" *ngIf="entity">
        <div class="col-12">
            <div class="row">
                <div class="form-group col-12 col-md-4">
                    <label for="situacao" class="col-form-label">Situação</label>
                    <sgt-motivo-perda-venda-situacao-select
                        [(ngModel)]="entity.situacao"
                        #situacao="ngModel"
                        name="situacao"
                        id="situacao"
                        required="required"
                        [canSelectNull]="false">
                    </sgt-motivo-perda-venda-situacao-select>
                    <sgt-form-control-error
                        *ngIf="situacao.errors && situacao.errors.required && situacao.dirty"
                        msgError="A situação é obrigatório">
                    </sgt-form-control-error>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-12">
                    <label for="nome" class="col-form-label">Nome</label>
                    <input type="text" class="form-control " [(ngModel)]="entity.nome" name="nome" id="nome"
                        #nome="ngModel" required="required" maxlength="255" [autofocus]="true" sgtUppercase>
                    <sgt-form-control-error
                        *ngIf="nome.errors && nome.errors.required && nome.dirty"
                        msgError="O nome é obrigatório">
                    </sgt-form-control-error>
                    <sgt-form-control-error
                        *ngIf="nome.errors && nome.errors.maxlength"
                        msgError="O nome deve ter no máximo 255 caracteres">
                    </sgt-form-control-error>
                </div>
            </div>

            <!-- Exibição -->
            <div class="row">
                <div class="form-group col-12">
                    <sgt-motivo-perda-venda-exibicao-form
                        #exibicaoForm
                        [entity]="entity">
                    </sgt-motivo-perda-venda-exibicao-form>
                </div>
            </div>

            <!-- Ciclo de Vida do Produto (PLM) -->
            <div class="row">
                <div class="form-group col-12">
                    <sgt-motivo-perda-venda-plm-form
                        #plmForm
                        [entity]="entity">
                    </sgt-motivo-perda-venda-plm-form>
                </div>
            </div>

            <div class="row">
                <div class="form-group col-12">
                    <sgt-motivo-perda-venda-oportunidade-form
                        #oportunidadeForm
                        [entity]="entity">
                    </sgt-motivo-perda-venda-oportunidade-form>
                </div>
            </div>

            <div class="row">
                <div class="form-group col-12">
                    <sgt-motivo-perda-venda-concorrente-form
                        #concorrenteForm
                        [entity]="entity">
                    </sgt-motivo-perda-venda-concorrente-form>
                </div>
            </div>

            <div class="row">
                <div class="form-group col-12">
                    <div class="card motivo-perda-venda-market-share">
                        <div class="card-header">
                            <h6 class="card-title">
                                Análise de Market Share
                            </h6>
                            <p class="form-text text-muted">
                                Selecione em quais momentos este motivo deve ser exibido e ficar disponível para ser selecionado na Análise de Market Share
                            </p>
                        </div>
                        <ul class="list-group list-group-flush">
                            <li class="list-group-item">
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.reaberturaMarketShare" name="reaberturaMarketShare" id="reaberturaMarketShare">
                                    <label class="custom-control-label" for="reaberturaMarketShare">Reabertura de market share</label>
                                </div>
                                <p class="form-text text-muted">Selecione esta opção se deseja exibir este motivo na reabertura de um mercado aprovado</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
